/**
 * Sorts an array of items alphabetically by the `Name` property.
 * Uses localeCompare for proper string comparison and supports empty values safely.
 */

export const sortByName = <T extends { Name?: string }>(items: T[]) => {
  return [...items].sort((a, b) => (a.Name || '').trim().localeCompare((b.Name || '').trim()));
};
